/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export function debounce(func: (...args: any) => any, wait = 20) {
  let timeoutHandle: number | null = null;

  if (timeoutHandle) {
    window.clearTimeout(timeoutHandle);
  }

  timeoutHandle = window.setTimeout(() => func(), wait);
}
